import { Component, ElementRef, HostListener, TemplateRef, ViewChild, OnInit, AfterViewInit, OnDestroy, Type } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { City } from 'src/app/models/city';
import { KeyNameModel, KeyTitleModel } from 'src/app/models/key-value-model';
import { UserService } from 'src/app/services/user.service';
import { MenuComponent } from 'src/app/shared/components/menu/menu.component';
import { CustomValidators } from 'src/app/shared/validators/custom.validator';
import { CompleteInfoModalComponent } from '../complete-info-modal/complete-info-modal.component';
import { ConfirmInfoModalComponent } from '../confirm-info-modal/confirm-info-modal.component';
import { Business, BusinessHour, BusinessImage, BusinessMenu } from 'src/app/models/register-business';
import { EMPTY, Observable, Subscription, catchError, finalize, from, switchMap, zip } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessService } from 'src/app/services/business.service';
import { BusinessHourModalComponent } from '../business-hour-modal/business-hour-modal.component';
import { ProfileModalComponent } from '../profile-modal/profile-modal.component';
import { SearchLocationModalComponent } from '../search-location-modal/search-location-modal.component';
import { RegistrationDoneModalComponent } from '../registration-done-modal/registration-done-modal.component';
import { ProductUploadComponent } from '../../shared/components/product-upload/product-upload.component';
import { ImageConfigurationComponent } from '../../shared/components/image-configuration/image-configuration.component';
import { ImageConfiguration } from '../../models/image-configuration';
import heic2any from 'heic2any';
import { RestoPublishInfoPopupComponent } from '../resto-publish-info-popup/resto-publish-info-popup.component';
import { BusinessUploadComponent } from '../../shared/components/business-upload/business-upload.component';
import { MiniMenuSettingsComponent } from '../mini-menu-settings/mini-menu-settings.component';
import { MarketplaceEntryService } from '../../services/marketplace-entry.service';
import { LocationSelection, locationCity, validLocation } from 'src/app/services/location-lookup.service';
import { PLACES_ENABLED, loadPlacesSettings } from '../../places-routes';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
})
export class OnboardingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('menu') menuComponent!: MenuComponent;
  @ViewChild('productUploadModal') productUploadComponent!: ProductUploadComponent;
  @ViewChild('businessUploadModal') businessUploadComponent!: BusinessUploadComponent;
  @ViewChild('completeInfoModal')
  completeInfoComponent!: CompleteInfoModalComponent;
  @ViewChild('confirmationModal')
  confirmInfoComponent!: ConfirmInfoModalComponent;
  @ViewChild('businessHourModal')
  businessHourModalComponent!: BusinessHourModalComponent;
  @ViewChild('profileModal') profileTemplate!: TemplateRef<any>;
  @ViewChild('searchLocationModal')
  searchLocationComponent!: SearchLocationModalComponent;
  //@ViewChild('imageConfigurationModal')
  //imageConfiurationComponent!: ImageConfigurationComponent;
  @ViewChild('registrationDoneModal')
  registrationDoneComponent!: RegistrationDoneModalComponent;
  @ViewChild('restoInfoModal')
  restoInfoModalComponent!: RestoPublishInfoPopupComponent;
  @ViewChild('publishConfirmModal') publishConfirmModal!: TemplateRef<any>;
  @ViewChild('placesRemovalConfirmModal') placesRemovalConfirmModal!: TemplateRef<any>;
  savingBusinessDetails = false;
  @ViewChild('miniMenuSettings') miniMenuSettings!: MiniMenuSettingsComponent;
  @ViewChild('searchLocationModal', { static: false }) searchLocationModal: ElementRef;
  active = 0;
  activeDishPanel = 0;
  isOnboardingSidebarActive = false;
  activeSection: string = 'items-1';
  readonly placesEnabled = PLACES_ENABLED;
  placesSettingsType: Type<any> | null = null;
  placesSettingsLoading = false;
  placesSettingsError = '';
  placesRefreshToken = 0;
  private readonly managePlacesSubscription = () => this.openMarketplace();
  get placesSettingsInputs(): Record<string, unknown> {
    return { branchId: this.businessDetails.branchId, businessPartnerId: this.businessDetails.businessPartnerId,
      refreshToken: this.placesRefreshToken, manageSubscriptionAction: this.managePlacesSubscription };
  }
  openPlacesSettings(): void {
    if (!this.placesEnabled) return;
    this.scrollToSection('items-6');
    if (this.placesSettingsType || this.placesSettingsLoading || !(this.businessDetails.branchId > 0)) return;
    this.placesSettingsLoading = true; this.placesSettingsError = '';
    loadPlacesSettings().then(component => { this.placesSettingsType = component; },
      () => { this.placesSettingsError = 'We could not load Places settings. Please try again.'; })
      .finally(() => { this.placesSettingsLoading = false; });
  }
  private scrollActiveSection: string = 'items-1';
  private clickActiveSection: string | null = null;
  imageUrls: BusinessImage[] = [];
  typeSelect: KeyTitleModel;
  cuisineSelect: KeyTitleModel;
  priceSelect!: KeyTitleModel;
  aminitySelect!: KeyTitleModel;
  types: KeyTitleModel[] = [];
  cuisines: KeyTitleModel[] = [];
  menuCategories: KeyTitleModel[] = [];
  photoCategories: KeyNameModel[] = [];
  dayOfWeek: KeyNameModel[] = [];
  amenities: KeyTitleModel[] = [];
  priceRanges: KeyTitleModel[] = [];
  selectedAmenities: KeyTitleModel[] = [];
  cities: City[] = [];
  businessDetails: Business = new Business();
  isFileInputEnabled: boolean = true;
  product: BusinessMenu = new BusinessMenu();
  citySelect!: City;
  hourList: BusinessHour[] = [];
  products: BusinessMenu[] = [];
  typeOfMeals: KeyTitleModel[] = [];
  selectedTypeOfMeals: any[] = [];
  selectedTab = 1;
  initialLat: number;
  initialLng: number;
  locations: {
    address: string;
    latitude: number;
    longitude: number;
    name?: string;
    premises_name?: string;
  }[] = [];
  imageConfiguration: any;
  subscribeImages: Subscription;
  private modalRef!: NgbModalRef;
  private menuSubscription!: Subscription;
  draftBusinesses: KeyTitleModel[] = [];
  isPreRegistration: boolean = false;
  businessSelect: KeyTitleModel;
  memberShipBranchImagesList: any[] = [];
  allowPublish: boolean = true;
  private branchRedirectIntervalId: ReturnType<typeof setInterval> | null = null;
  openingMarketplace = false;
  marketplaceEntryError = '';
  private marketplaceEntryRequest?: Subscription;
  private pendingMarketplaceWindow?: Window;
  private marketplaceWasOpened = false;
  private locationCityRequest?: Subscription;
  private automaticAddress = '';
  private businessLookupsLoaded = false;
  private businessRouteResolved = false;

  get showSubscriptionSaveNote(): boolean {
    // The empty model also represents an existing business while it loads.
    // Show save guidance only after resolving an actually new business.
    return this.businessLookupsLoaded && this.businessRouteResolved &&
      this.businessDetails.branchId === 0 &&
      !(this.businessDetails.businessPartnerId > 0) && !(this.businessSelect?.id > 0);
  }

  constructor(
    private elRef: ElementRef,
    private modalService: NgbModal,
    private userService: UserService,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private businessService: BusinessService,
    private router: Router,
    public marketplaceEntry: MarketplaceEntryService
  ) { }

  ngOnInit(): void {
    this.isPreRegistration = this.router.url.startsWith('/pre-registration');
    this.businessRouteResolved = this.isPreRegistration;
    // Set initial active section
    this.activeSection = 'items-1';
    this.scrollActiveSection = 'items-1';

    this.loaderService.setLoading(true);
    const checkInterval = 100; // Check every 100ms
    const maxDuration = 2000; // Max duration of 2 seconds
    const startTime = Date.now();

    if (!this.isPreRegistration) {
      this.branchRedirectIntervalId = setInterval(() => {
        const branchId = localStorage.getItem('branchId');

        if (branchId) {
          this.clearBranchRedirectInterval();
          this.router.navigate(['/onboarding', branchId]); // Redirect to the onboarding page with branchId
        } else if (Date.now() - startTime >= maxDuration) {
          this.clearBranchRedirectInterval();
          this.businessRouteResolved = true;
          this.loaderService.setLoading(false); // Stop loading if branchId is not found
        }
      }, checkInterval);
    }

    // Continue with the existing logic
    this.route.params.subscribe((params) => {
      if (params['branchId']) {
        this.businessDetails.branchId = params['branchId'];
        this.businessRouteResolved = true;
      }
    });

    this.getDraftBusinesses();

    // Existing logic to fetch data
    zip(
      this.userService.getAll(`/api/tenants/membershipApp/GetAllMembershipAppCompanySubCategory`),
      this.userService.getAll(`/api/tenants/membershipApp/GetMembershipAppCompanyTypes`),
      this.userService.getAll(`/api/tenants/membershipApp/GetMembershipAppAmenities`),
      this.userService.getAll(`api/getEnumList/MembershipBranchImageType`),
      this.userService.getAll(`api/tenants/membershipApp/GetMembershipAppCompanyPriceRange`),
      this.userService.getAll(`api/getEnumList/dayofweek`),
      this.userService.getAll(`api/tenants/membershipApp/GetCompanyMenue?SubBranchId=${this.businessDetails.branchId}&SkipPaging=true`),
      this.userService.getAll(`api/tenants/membershipApp/getAllMembershipAppMealTypeList`),
    ).subscribe(([subCategories, types, amenities, photoCategories, priceRanges, dayOfWeek, products, typeOfMeals]: any[]) => {
      this.cuisines = this.sortItems(subCategories.map((item: { id: any; displayTitle: any; }) => ({
        id: item.id,
        title: item.displayTitle,
      })));

      this.types = this.sortItems(types.map((item: { id: any; title: any; }) => ({
        id: item.id,
        title: item.title,
      })));

      this.amenities = this.sortItems(amenities.map((item: { id: any; title: any; }) => ({
        id: item.id,
        title: item.title,
      })));

      this.photoCategories = photoCategories.map((item: { value: any; enumDescription: any; }) => ({
        id: item.value,
        name: item.enumDescription,
      }));

      this.priceRanges = this.sortItems(priceRanges.map((item: { id: any; title: any; }) => ({
        id: item.id,
        title: item.title,
      })));

      this.dayOfWeek = dayOfWeek.map((item: { value: any; enumName: any; }) => ({
        id: item.value,
        name: item.enumName,
      }));
      this.products = products.records.map((product: { id: any; title: any; productCategoryId: any; image: any; price: any; description: any; productImages: { id: any; }[]; }) => ({
        id: product.id,
        title: product.title,
        productCategoryId: product.productCategoryId,
        productImageUrl: product.image,
        price: product.price,
        description: product.description,
        productImageId: product.productImages[0]?.id
      }));

      this.typeOfMeals = typeOfMeals.map((type: { id: any; displayTitle: any; }) => ({
        id: type.id,
        title: type.displayTitle,
      }));

      this.businessLookupsLoaded = true;

      if (
        this.businessDetails.branchId != 0
      ) {
        localStorage.setItem("branchId", this.businessDetails.branchId.toString());
        this.getBusinessDetails();
      }
      else {
        this.loaderService.setLoading(false);
      }
    });
  }

  openMarketplace(): void {
    if (this.openingMarketplace || !this.marketplaceEntry.isConfigured || !(this.businessDetails.businessPartnerId > 0)) {
      return;
    }
    this.openingMarketplace = true;
    this.marketplaceEntryError = '';
    // Reserve the window during the click so the asynchronous exchange does not
    // get blocked as a popup. Isolate it before sending it to Marketplace.
    try {
      this.pendingMarketplaceWindow = window.open('', '_blank') || undefined;
      if (this.pendingMarketplaceWindow) this.pendingMarketplaceWindow.opener = null;
    } catch {
      this.closePendingMarketplaceWindow();
    }
    if (!this.pendingMarketplaceWindow) {
      this.openingMarketplace = false;
      this.marketplaceEntryError = 'Allow pop-ups, then select Subscriptions again.';
      return;
    }
    this.marketplaceEntryRequest = this.marketplaceEntry.createEntry().pipe(
      finalize(() => this.openingMarketplace = false)
    ).subscribe({
      next: url => {
        const destination = this.pendingMarketplaceWindow;
        try {
          if (destination && !destination.closed) {
            destination.location.replace(url);
            this.pendingMarketplaceWindow = undefined;
            this.marketplaceWasOpened = true;
            return;
          }
        } catch {
          // Leave the editor in place so the owner can retry from Subscriptions.
        }
        this.closePendingMarketplaceWindow();
        this.marketplaceEntryError = 'EVOLUTION Marketplace could not be opened. Please select Subscriptions again.';
      },
      error: error => {
        this.closePendingMarketplaceWindow();
        this.marketplaceEntryError = error?.status === 401
          ? 'Please sign in to HUNGERY again, then open EVOLUTION Marketplace.'
          : 'EVOLUTION Marketplace could not be opened. Please try again.';
      },
    });
  }

  private closePendingMarketplaceWindow(): void {
    try { this.pendingMarketplaceWindow?.close(); } catch { /* Browser already disposed of the popup. */ }
    this.pendingMarketplaceWindow = undefined;
  }

  @HostListener('window:focus')
  refreshMarketplaceAvailability(): void {
    if (this.marketplaceWasOpened) {
      this.miniMenuSettings?.refreshAvailability();
      this.placesRefreshToken++;
    }
  }

  ngAfterViewInit() {
    // Ensure the active section is set after view initialization
    setTimeout(() => {
      this.activeSection = 'items-1';
      this.scrollActiveSection = 'items-1';
    }, 100);
  }

  viewOnboardingSideBar() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 992) {
      this.isOnboardingSidebarActive = !this.isOnboardingSidebarActive;
    }
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (this.elRef && !this.elRef.nativeElement.contains(event.target)) {
      this.isOnboardingSidebarActive = false;
    }
  }

  onScroll(event: any) {
    if (this.clickActiveSection) {
      return; // Don't process scroll events while click animation is active
    }

    const container = event.target;
    const sections = ['items-1', 'items-2', 'items-3', 'items-4', 'items-5', ...(this.placesEnabled ? ['items-6'] : [])];

    // Find the section that is currently most visible
    let maxVisibleSection = sections[0];
    let maxVisibleHeight = -1;

    sections.forEach(section => {
      const element = document.querySelector(`[ngbscrollspyfragment="${section}"]`);
      if (element) {
        const rect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // Calculate how much of the section is visible
        const visibleTop = Math.max(rect.top, containerRect.top);
        const visibleBottom = Math.min(rect.bottom, containerRect.bottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);

        if (visibleHeight > maxVisibleHeight) {
          maxVisibleHeight = visibleHeight;
          maxVisibleSection = section;
        }
      }
    });

    this.scrollActiveSection = maxVisibleSection;
    this.activeSection = this.scrollActiveSection;
  }

  formGroup = new FormGroup({
    Name: new FormControl('', Validators.required),
    Address: new FormControl('', Validators.maxLength(255)),
    Phone: new FormControl('', [
      Validators.minLength(7),
      Validators.maxLength(15),
      CustomValidators.PhoneNumberValidator(),
    ]),
    Website: new FormControl('', [
      CustomValidators.urlValidator(),
      Validators.maxLength(255),
    ]),
    Instagram: new FormControl('', [
      Validators.maxLength(30),
    ]),
    Twitter: new FormControl('', [
      CustomValidators.twitterValidator(),
      Validators.minLength(5),
      Validators.maxLength(15),
    ]),
    BusinessMessage: new FormControl(''),
    Description: new FormControl(''),
    BusinessHourDescription: new FormControl(''),
    Location: new FormControl(''),
    Longitude: new FormControl(null, [
      Validators.pattern(/^[-+]?[0-9]*\.?[0-9]+$/) // Regex to allow numbers and decimals
    ]),
    Latitude: new FormControl(null, [
      Validators.pattern(/^[-+]?[0-9]*\.?[0-9]+$/) // Regex to allow numbers and decimals
    ])
  });

  getBusinessDetails() {
    this.locationCityRequest?.unsubscribe();
    this.automaticAddress = '';
    this.loaderService.setLoading(true);
    this.businessService.getBusiness().subscribe((response: Business) => {
      this.businessDetails = response;
      this.getProductCategories();
      this.formGroup.patchValue({
        Name: response.name,
        Address: response.address,
        Phone: response.phoneNumber,
        Website: response.website,
        Instagram: response.instagram,
        Twitter: response.twitter,
        BusinessMessage: response.businessMessage,
        Description: response.description,
        Latitude: response.lat,
        Longitude: response.lng,
        Location: response.addressLine2
      });

      // Set initialLatLng from business lat and lng
      if (response.lat) {
        this.initialLat = response.lat;
      }
      if (response.lng) {
        this.initialLng = response.lng;
      }

      console.log('initialLatLng', this.initialLat, this.initialLng);

      let selectedCuisine = this.cuisines.find(
        (item) => item.id === response.cuisineId
      );
      this.cuisineSelect = selectedCuisine ?? null;

      let selectedType = this.types.find((item) => item.id === response.typeId);
      this.typeSelect = selectedType ?? null;

      if (response.cityName != null && response.cityName != "") {
        this.getCitiesBySearchText(response.cityName, response.cityId);
      }

      let selectedPrice = this.priceRanges.find(
        (item) => item.id === response.priceRangeTypeId
      );
      this.priceSelect = selectedPrice ?? null;

      if (response.amenities != null) {
        this.selectedAmenities = [];
        this.selectedAmenities.push(...response.amenities);
      }

      if (response.membershipAppMealTypeList != null) {
        this.selectedTypeOfMeals = [];
        this.selectedTypeOfMeals.push(...response.membershipAppMealTypeList.map((item) => item.id));
      }

      if (response.membershipAppCompanyBusinessHourList && response.membershipAppCompanyBusinessHourList.length > 0) {
        this.hourList = response.membershipAppCompanyBusinessHourList.map((hour: { id: any; day: number; from: any; to: any; }) => ({
          id: hour.id,
          isOpen: true,
          Day: this.dayOfWeek.find(x => x.id == hour.day)?.name,
          From: hour.from,
          To: hour.to,
        }));
      }
      if (response.membershipBusinessImagesList != null) {
        response.membershipBusinessImagesList.map(image => {
          this.setCroppedImages(image, false);
        })
      }
      this.businessHourAdded(this.hourList);
      this.loaderService.setLoading(false);
    });
  }

  getBusinessImages() {
    this.loaderService.setLoading(true);
    this.userService
      .getById(
        `api/tenants/membershipApp/GetImageForMembershipBranch`,
        this.businessDetails.branchId
      )
      .pipe(
        catchError((error) => {
          if (error.status == 404) {
            throw error;
          } else {
            this.loaderService.setLoading(false);
            throw error;
          }
        })
      )
      .subscribe((response: any) => {
        this.imageUrls.push(
          ...response.map((item: { imagePath: any; imageType: any; id: any; }) => ({
            imageUrl: item.imagePath,
            categoryId: item.imageType,
            imageId: item.id
          }))
        );
        this.loaderService.setLoading(false);
      });
  }

  openMenuItemModal(menuItemModal: TemplateRef<any>, windowClass = '') {
    if (this.businessDetails.branchId != 0) {
      this.modalRef = this.modalService.open(menuItemModal, {
        windowClass: windowClass,
        centered: true,
      });
      if (menuItemModal == this.menuComponent.menuModalTemplate) {
        this.menuComponent.setDishValues(new BusinessMenu());
        this.menuComponent.foodPreviewAdded = false;

        this.menuSubscription = this.menuComponent.saveMenuSuccess.subscribe(() => {
          this.closeMenuModal();
        });
      }
    }
  }

  closeMenuModal = () => {
    if (this.modalRef) {
      this.modalRef.close('Saved');
    }
  }

  openProductUploadModal(productUploadModal: TemplateRef<any>, windowClass = '') {
    if (this.businessDetails.branchId != 0) {
      this.modalService.open(productUploadModal, {
        windowClass: windowClass,
        centered: true,
      });
    }
  }

  openBusinessUploadModal(businessUploadModal: TemplateRef<any>, windowClass = '') {
    this.modalService.open(businessUploadModal, {
      windowClass: windowClass,
      centered: true,
    });
  }

  sortItems(items: any[]): any[] {
    return items.slice().sort((item1, item2) => {
      if (item1.title.toLowerCase() < item2.title.toLowerCase()) {
        return -1;
      }
      if (item1.title.toLowerCase() > item2.title.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }

  addAminity() {
    if (this.aminitySelect != undefined) {
      if (!this.selectedAmenities.find((x) => x.id == this.aminitySelect.id)) {
        this.selectedAmenities.push(this.aminitySelect);
      }
    }
    this.aminitySelect = null;
  }

  async onFileSelected(event: Event, imageCategory: number): Promise<void> {
    const fileInput = event.target as HTMLInputElement;
    if (!fileInput.files || fileInput.files.length === 0) {
      this.toastr.error('No file selected.');
      return;
    }

    if (fileInput.files && fileInput.files.length > 0) {
      let file = fileInput.files[0];

      const fileName = file.name.toLocaleLowerCase();
      const extension = fileName.split('.').pop();

      const isHeicOrHeif = file.type === 'image/heic' || file.type === 'image/heif' || (!file.type && (extension === 'heic' || extension === 'heif'));

      if (isHeicOrHeif) {
        try {
          const convertedBlob = await heic2any({ blob: file, toType: 'image/jpeg' });
          file = new File(
            [convertedBlob as Blob],
            file.name.replace(/\.(heic|heif)$/i, '.jpg'), {
            type: 'image/jpeg'
          });
        }
        catch (error) {
          this.toastr.error('Failed to convert HEIC/HEIF image.');
          return;
        }
      }

      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.imageConfiguration = e.target?.result as String;
        modalRef.componentInstance.inputImg = this.imageConfiguration;
      }
      reader.readAsDataURL(file);

      if (!file.type.startsWith('image/')) {
        this.toastr.error('Please select image.');
        return;
      }

      const modalRef = this.modalService.open(ImageConfigurationComponent, {
        windowClass: "project-modal edit-food-menu-modal",
        centered: true,
        backdrop: 'static'
      });
      modalRef.result.then((event: any) => {
        if (event != null) {
          const formData = new FormData();
          formData.append('Content', file);
          formData.append('imageConfiguration', JSON.stringify(event));
          this.uploadImage(formData, imageCategory, file, event);
        }
      });

    }
  }

  uploadImage(data: FormData, imageCategory: number, imageFile: File, event: any) {
    // TODO: Image compression is temporarily disabled as per requirement
    this.loaderService.setLoading(true);
    this.userService
      .uploadBusinessImage(
        `api/tenants/membershipApp/SaveImageForMembershipBranch`,
        data,
        this.businessDetails.branchId,
        imageCategory
      )
      .pipe(
        catchError((error) => {
          if (error.status == 404) {
            throw error;
          } else {
            this.loaderService.setLoading(false);
            throw error;
          }
        })
      )
      .subscribe((response: any) => {
        var imageUrl = URL.createObjectURL(imageFile);
        const image = {
          imagePath: imageUrl,
          imageType: imageCategory,
          id: response[0].id,
          memberShipImageConfigurationViews: event
        }
        this.setCroppedImages(image, true);
        this.toastr.success('Image uploaded successfully!');
        this.loaderService.setLoading(false);
      });
  }

  getImagesByCategory(categoryId: number) {
    return this.imageUrls
      .filter((image) => image.imageType === categoryId);
  }

  async onEditImage(categoryId: number, imageId: number) {
    //let image;
    this.userService
      .getById(
        `api/tenants/membershipApp/GetImageForMembershipBranch`,
        this.businessDetails.branchId
      )
      .pipe(
        catchError((error) => {
          if (error.status == 404) {
            throw error;
          } else {
            this.loaderService.setLoading(false);
            throw error;
          }
        })
      )
      .subscribe((response: any) => {
        const modalRef = this.modalService.open(ImageConfigurationComponent, {
          windowClass: "project-modal edit-food-menu-modal",
          centered: true,
          backdrop: 'static'
        });
        const image = response.find(x => x.id == imageId);
        modalRef.componentInstance.inputImg = image.imagePath;
        modalRef.result.then((event: any) => {
          if (event != null) {
            this.imageURLToFile(image.imagePath, 'image.jpg').then(file => {
              const formData = new FormData();
              formData.append('Content', file);
              formData.append('imageConfiguration', JSON.stringify(event));
              this.updateImage(formData, categoryId, imageId, file, event);
            })
          }
        });

      });
  }

  async imageURLToFile(url: string, filename: string): Promise<File> {
    const response = await fetch(url);
    const blob = await response.blob();
    const contentType = response.headers.get("content-type") || "image/jpeg";
    return new File([blob], filename, { type: contentType });
  }

  updateImage(data: FormData, categoryId: number, imageId: number, imageFile: File, event: any) {
    this.userService.updateBusinessImage(`api/tenants/membershipApp/UpdateImageForMembershipBranch`, data, this.businessDetails.branchId, categoryId, imageId)
      .pipe(
        catchError((error) => {
          if (error.status == 404) {
            throw error;
          }
          else {
            this.loaderService.setLoading(false);
            throw error;
          }
        })
      )
      .subscribe((response: any) => {
        const index = this.imageUrls.findIndex(obj => obj.id === imageId);

        if (index !== -1) {
          this.imageUrls.splice(index, 1);
        }
        var imageUrl = URL.createObjectURL(imageFile);
        const image = {
          imagePath: imageUrl,
          imageType: categoryId,
          id: response.id,
          memberShipImageConfigurationViews: event
        }
        this.setCroppedImages(image, true);
        this.toastr.success('Image edited successfully!');
        this.loaderService.setLoading(false);
      });
  }

  onDeleteImage(imageId: number) {
    this.loaderService.setLoading(true);
    this.userService.delete(`api/tenants/membershipApp/DeleteImageForMembershipBranch`, imageId).pipe(
      catchError((error) => {
        if (error.status == 404) {
          throw error;
        }
        else {
          this.loaderService.setLoading(false);
          throw error;
        }
      })
    )
      .subscribe((response) => {
        this.imageUrls = this.imageUrls.filter(x => x.id != imageId);
        this.toastr.success('Image deleted successfully!');
        this.loaderService.setLoading(false);
      });
  }

  getCitiesBySearchText(searchText: string | null, selectedCityId?: number) {
    this.locationCityRequest?.unsubscribe();
    const query = (searchText || '').trim();
    if (query.length > 2) {
      this.locationCityRequest = this.userService
        .getAll(`api/citystatecountry/getcitiesbyname/${encodeURIComponent(query)}`)
        .subscribe({ next: (response: any) => {
          this.cities = this.sortItems(
            response.map((item: { id: any; name: any; uniqueId: any; stateName: any; countryName: any; }) => ({
              id: item.id,
              name: item.name,
              uniqueId: item.uniqueId,
              stateName: item.stateName,
              countryName: item.countryName,
              title: item.name,
            })));
          let selectedCity = this.cities.find(
            (item) => item.id === selectedCityId
          );
          if (selectedCityId != null) this.citySelect = selectedCity;
        }, error: () => { this.toastr.info('Unable to load cities. Please try again.'); } });
    } else {
      this.cities = [];
    }
  }

  getCitiesBySearchTextAuto(searchText: string | null, countryName?: string) {
    this.locationCityRequest?.unsubscribe();
    const query = (searchText || '').trim();
    if (query.length > 2) {
      this.locationCityRequest = this.userService
        .getAll(`api/citystatecountry/getcitiesbyname/${encodeURIComponent(query)}`)
        .subscribe({ next: (response: any) => {
          this.cities = this.sortItems(
            response.map((item: { id: any; name: any; uniqueId: any; stateName: any; countryName: any; }) => ({
              id: item.id,
              name: item.name,
              uniqueId: item.uniqueId,
              stateName: item.stateName,
              countryName: item.countryName,
              title: item.name,
            })));
          // Only an unambiguous name match should choose the business's city.
          const matches = this.cities.filter(city => city.name?.toLocaleLowerCase() === query.toLocaleLowerCase()
            && (!countryName || city.countryName?.toLocaleLowerCase() === countryName.toLocaleLowerCase()));
          if (!this.citySelect && matches.length === 1) this.citySelect = matches[0];
        }, error: () => { this.toastr.info('Please select your city manually.'); } });
    }
  }

  updateCityListOnBlur(searchText: string) {
    if (!this.citySelect) {
      this.cities = [];
    }
  }

  openModal(modal: TemplateRef<any>) {
    if (
      modal == this.completeInfoComponent.completeInfoTemplate &&
      this.businessDetails.branchId == 0
    ) {
      this.isFileInputEnabled = false;
      this.modalService.open(modal, {
        windowClass: 'warning-section-modal',
        centered: true,
        size: 'sm',
      });
    } else {
      this.isFileInputEnabled = true;
    }

    if (modal == this.confirmInfoComponent.confirmInfoTemplate) {
      this.modalService.open(modal, {
        windowClass: 'warning-section-modal',
        centered: true,
        size: 'sm',
      });
    }
  }

  openPublishConfirmModal() {
    this.modalService.open(this.publishConfirmModal, {
      windowClass: 'warning-section-modal publish-confirm-modal',
      centered: true,
      size: 'sm',
    });
  }

  fromGroupTouched(isSubmit: boolean = false) {
    if (this.formGroup.touched || isSubmit) {
      this.formGroup.markAllAsTouched();
      this.formGroup.updateValueAndValidity();
    }
  }

  saveBusinessDetails() {
    if (this.savingBusinessDetails) return;
    this.fromGroupTouched(true);
    if (this.formGroup.invalid) {
      return;
    } else {
      // Mini Menu settings ride the same Save Details action (static/localStorage phase).
      this.miniMenuSettings?.save();
      //this.formGroup.controls['Latitude'].patchValue(22.3038945);
      //this.formGroup.controls['Longitude'].patchValue(70.80215989999999);
      this.userService.getCountryFromGoogleMaps(this.formGroup.get('Latitude').value, this.formGroup.get('Longitude').value).then((country) => {
        if (this.userService.allowedCountries.includes(country)) {
          if (this.businessDetails.branchId != 0) {
            this.registerBusiness();
          }
          else {
            this.openModal(this.confirmInfoComponent.confirmInfoTemplate);
          }
        }
        else {
          this.toastr.info("We're sorry, but registration is currently not available in your region. As a result, you will not be able to create/update business at selected location. We appreciate your interest and apologize for any inconvenience.");
          return;
        }
      });
    }
  }

  registerBusiness() {
    if (this.savingBusinessDetails) return;
    this.businessDetails.name = this.formGroup.get('Name').value;
    this.businessDetails.address = this.formGroup.get('Address').value ?? '';
    this.businessDetails.businessMessage =
      this.formGroup.get('BusinessMessage').value ?? '';
    this.businessDetails.description =
      this.formGroup.get('Description').value ?? '';
    this.businessDetails.phoneNumber = this.formGroup.get('Phone').value ?? '';
    this.businessDetails.instagram =
      this.formGroup.get('Instagram').value ?? '';
    this.businessDetails.twitter = this.formGroup.get('Twitter').value ?? '';
    this.businessDetails.website = this.formGroup.get('Website').value ?? '';
    this.businessDetails.cuisineId =
      this.cuisineSelect != null && this.cuisineSelect != undefined
        ? this.cuisineSelect.id
        : null;
    this.businessDetails.cityId =
      this.citySelect != null && this.citySelect != undefined
        ? this.citySelect.id
        : null;
    //this.businessDetails.cityId = 113276;
    this.businessDetails.typeId =
      this.typeSelect != null && this.typeSelect != undefined
        ? this.typeSelect.id
        : null;
    this.businessDetails.priceRangeTypeId =
      this.priceSelect != null && this.priceSelect != undefined
        ? this.priceSelect.id
        : null;
    this.businessDetails.lat = this.formGroup.get('Latitude').value ?? '';
    this.businessDetails.lng = this.formGroup.get('Longitude').value ?? '';
    this.businessDetails.addressLine2 = this.formGroup.get('Location').value ?? '';
    if (this.selectedAmenities.length > 0) {
      this.businessDetails.amenities = [];
      this.businessDetails.amenities.push(...this.selectedAmenities);
    }
    else {
      this.businessDetails.amenities = [];
    }

    if (this.selectedTypeOfMeals.length > 0) {
      this.businessDetails.membershipAppMealTypeList = [];
      this.selectedTypeOfMeals.forEach(id => {
        const selectedItem = this.typeOfMeals.find(item => item.id === id);
        if (selectedItem) {
          this.businessDetails.membershipAppMealTypeList.push(selectedItem);
        }
      });
    }
    else {
      this.businessDetails.membershipAppMealTypeList = [];
    }
    this.businessDetails.membershipAppCompanyBusinessHourList = [];
    this.hourList.forEach(hour => {
      if (hour.From != "" || hour.To != "")
        this.businessDetails.membershipAppCompanyBusinessHourList.push({
          id: hour.id,
          Day: hour.Day,
          From: hour.From,
          To: hour.To,
          isOpen: true
        });
    });
    this.businessDetails.isPreRegistration = this.isPreRegistration;

    if (this.businessDetails.branchId != 0) {
      // Keep the exact submitted values while the owner confirms removal.
      const payload = JSON.parse(JSON.stringify(this.businessDetails));
      this.savingBusinessDetails = true;
      this.loaderService.setLoading(true);
      this.userService.updateBusinessDetails(payload)
        .pipe(
          catchError((error) => {
            const token = error.error?.details?.confirmationToken;
            if (error.status !== 409 || error.error?.code !== 'places-removal-confirmation-required' ||
                typeof token !== 'string' || !token.trim()) throw error;
            this.loaderService.setLoading(false);
            const modal = this.modalService.open(this.placesRemovalConfirmModal, {
              windowClass: 'warning-section-modal', centered: true, size: 'sm'
            });
            return from(modal.result.then(result => result === true, () => false)).pipe(
              switchMap(confirmed => {
                if (!confirmed) return EMPTY;
                this.loaderService.setLoading(true);
                return this.userService.updateBusinessDetails(payload, token);
              })
            );
          }),
          finalize(() => {
            this.savingBusinessDetails = false;
            this.loaderService.setLoading(false);
          })
        )
        .subscribe({ next: (response) => {
          this.businessDetails.branchId = response.branchId;
          // Saving may change Places qualification or remove an affiliation even
          // when the branch ID stays the same and this editor remains mounted.
          this.placesRefreshToken++;
          localStorage.setItem('title', response.name);
          if (this.cuisineSelect != null) {
            localStorage.setItem('cuisineName', response.cuisineName);
          }
          if (this.typeSelect != null) {
            localStorage.setItem('typeName', response.typeName);
          }
          this.hourList = response.membershipAppCompanyBusinessHourList.map((hour: { id: any; from: any; to: any; day: number; }) => ({
            id: hour.id,
            From: hour.from,
            To: hour.to,
            isOpen: true,
            Day: this.dayOfWeek.find(x => x.id == hour.day)?.name,
          }));
          this.businessHourModalComponent.hourList = this.hourList;
          this.toastr.success('Business Updated successfully!');
          if (this.businessDetails.showPublishButton && this.businessDetails.branchId > 0) {
            // Pre-approved but not yet published: ask whether to publish now or keep editing
            // (replaces the standalone Publish button).
            this.loaderService.setLoading(false);
            this.openPublishConfirmModal();
            return;
          }
          if (!this.isPreRegistration) {
            this.businessService.businessDataUpdated.next(response);
            this.router.navigate(['business-detail', this.businessDetails.branchId]);
          }
          else {
            this.getDraftBusinesses(true);
          }
          this.loaderService.setLoading(false);
        }, error: (error) => {
          // Other errors keep their existing interceptor handling. Never loop on a changed token.
          if (error.status === 409 && error.error?.code === 'places-removal-confirmation-required') {
            this.toastr.info('The Place or saved location changed. Please save again to review the current removal confirmation.');
          }
        } });
    }
    else {
      this.loaderService.setLoading(true);
      this.userService
        .create(`api/bliss/createBlissBusiness`, this.businessDetails)
        .pipe(
          catchError((error) => {
            if (error.status == 404) {
              throw error;
            } else {
              this.loaderService.setLoading(false);
              throw error;
            }
          })
        )
        .subscribe((response: Business) => {
          this.businessDetails.branchId = response.branchId;
          localStorage.setItem("branchId", this.businessDetails.branchId.toString());
          localStorage.setItem('title', this.businessDetails.name);
          if (this.cuisineSelect != null) {
            localStorage.setItem('cuisineName', this.cuisineSelect.title);
          }
          if (this.typeSelect != null) {
            localStorage.setItem('typeName', this.typeSelect.title);
          }

          this.hourList = response.membershipAppCompanyBusinessHourList.map((hour: { id: any; from: any; to: any; day: number; }) => ({
            id: hour.id,
            From: hour.from,
            To: hour.to,
            isOpen: true,
            Day: this.dayOfWeek.find(x => x.id == hour.day)?.name,
          }));
          this.businessHourModalComponent.hourList = this.hourList;
          this.toastr.success('Business Registered successfully!');
          if (!this.isPreRegistration) {
            this.businessService.businessDataUpdated.next(response);
            this.router.navigate(['business-detail', this.businessDetails.branchId]);
          }
          else {
            this.getDraftBusinesses(true);
          }
          this.loaderService.setLoading(false);
        });
    }
  }

  openBusinessHourModal(modal: TemplateRef<any>, windowClass = '') {
    this.modalService.open(modal, {
      windowClass: windowClass,
      centered: true,
    });
  }

  businessHourAdded(hourList: BusinessHour[]) {
    var hours = "";
    this.hourList = hourList;
    if (this.hourList.length > 0) {
      hourList.forEach(hour => {
        if (hour.From != "" || hour.To != "") {
          hours += hour.Day?.slice(0, 3) + " " + hour.From + " - " + hour.To + ', ';
        }
      });

      this.hourList?.forEach(hour => {
        if (hour.From != "" || hour.To != "") {
          if (hour.From.length == 7) {
            hour.From = "0" + hour.From;
          }
          if (hour.To.length == 7) {
            hour.To = "0" + hour.To;
          }
        }
      });
      this.formGroup.controls['BusinessHourDescription'].setValue(hours);
    }
  }

  getDayName(day: string): string {
    return day?.slice(0, 3);
  }

  checkNoRecord(categoryId: number) {
    return (this.products.findIndex(x => x.productCategoryId == categoryId) < 0);
  }

  menuAdded(product: BusinessMenu) {
    this.products.push(product);
  }

  productDeleted(productId: number) {
    this.products = this.products.filter(x => x.id != productId);
  }

  getProductsByCategory(categoryId: number) {
    return this.products
      .filter((product) => product.productCategoryId === categoryId);
  }

  menuUpdated(product: BusinessMenu) {
    let index = this.products.findIndex(menu => menu.id == product.id);
    if (index !== -1) {
      this.products[index] = product;
    }
  }

  cancelChanges() {
    if (!this.isPreRegistration) {
      if (this.businessDetails.branchId) {
        this.router.navigate(['business-detail', this.businessDetails.branchId]);
      } else {
        this.router.navigate(['/']);
      }
    } else {
      this.cancelPreRegistration();
    }
  }

  openModalLocation(modal: TemplateRef<any>, windowClass: string = '') {
    this.modalService.open(modal, {
      windowClass: `project-modal ${windowClass} set-location-modal-outer`,
      centered: true,
      backdropClass: 'primary-backdrop',
    });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.searchLocationModal && this.searchLocationModal.nativeElement && !this.searchLocationModal.nativeElement.contains(event.target)) {
      this.modalService.dismissAll();  // Dismiss all modals
    }
  }

  nextTab(): void {
    this.selectedTab = (this.selectedTab % 2) + 1;
  }

  extractPremisesName(data: any[]): any[] {
    return data.map(item => {
      if (!item.address || typeof item.address !== 'string') {
        return { ...item, premises_name: "" };
      }

      const premisesName = item.address.includes(",")
        ? item.address.split(",")[0].trim()
        : item.address.trim();

      return { ...item, premises_name: premisesName };
    });
  }

  FillAddressDetails(location: LocationSelection) {
    if (!validLocation(location)) return;
    this.locations = this.extractPremisesName([location]);
    this.updateFormWithLocationData(this.locations[0]);
    this.modalService.dismissAll();
  }

  private updateFormWithLocationData(location: any) {
    const { premises_name: premisesName = '', longitude, latitude } = location;
    const address = this.formGroup.controls['Address'].value || '';
    const replaceAddress = !address.trim() || address === this.automaticAddress;

    this.formGroup.patchValue({
      Location: premisesName,
      Longitude: longitude,
      Latitude: latitude,
      Address: replaceAddress ? location.address : address
    });
    if (replaceAddress) this.automaticAddress = location.address;
    this.initialLat = latitude;
    this.initialLng = longitude;
    this.locationCityRequest?.unsubscribe();

    if (!this.citySelect) {
      const cityName = this.getCityNameFromLocation(location);
      this.getCitiesBySearchTextAuto(cityName, location.addressComponent?.find(item => item.types.includes('country'))?.long_name);
    }
  }

  getCityNameFromLocation(location: any): string | null {
    return locationCity(location);
  }

  publishRestaurant = () => {
    if (this.isPreRegistration && !this.allowPublish) {
      this.toastr.warning("Please complete image cropping for this business before submitting");
      return;
    }
    this.loaderService.setLoading(true);
    this.userService
      .create(`api/bliss/business/publish`, this.businessDetails)
      .pipe(
        catchError((error) => {
          if (error.status == 404) {
            throw error;
          } else {
            this.loaderService.setLoading(false);
            throw error;
          }
        })
      )
      .subscribe(() => {
        this.businessDetails.showPublishButton = false;
        this.loaderService.setLoading(false);
        if (this.isPreRegistration) {
          this.cancelPreRegistration();
          return;
        }

        this.businessService.businessDataUpdated.next(this.businessDetails);
        this.modalService.open(this.restoInfoModalComponent.restoPublishTemplate, {
          windowClass: `project-modal add-profile-modal`,
          centered: true,
          backdropClass: 'primary-backdrop',
        });
      });
  }

  scrollToSection(sectionId: string) {
    // Set active section immediately on click
    this.clickActiveSection = sectionId;
    this.activeSection = sectionId;

    const container = document.querySelector('.scroll-block');
    const targetElement = document.querySelector(`[ngbscrollspyfragment="${sectionId}"]`);

    if (container && targetElement) {
      const containerRect = container.getBoundingClientRect();
      const targetRect = targetElement.getBoundingClientRect();
      const relativeTop = targetRect.top - containerRect.top;

      container.scrollTo({
        top: container.scrollTop + relativeTop,
        behavior: 'smooth'
      });

      // Clear click active section after scroll animation
      setTimeout(() => {
        this.clickActiveSection = null;
      }, 1000);
    }

    if (window.innerWidth < 992) {
      this.isOnboardingSidebarActive = false;
    }
  }

  closeProductModal(event: any) {
    if (event) {
      this.loaderService.setLoading(true);
      this.userService.getAll(`api/tenants/membershipApp/GetCompanyMenue?SubBranchId=${this.businessDetails.branchId}&SkipPaging=true`)
        .subscribe((products: any) => {
          this.products = products.records.map((product: { id: any; title: any; productCategoryId: any; image: any; price: any; description: any; productImages: { id: any; }[]; }) => ({
            id: product.id,
            title: product.title,
            productCategoryId: product.productCategoryId,
            productImageUrl: product.image,
            price: product.price,
            description: product.description,
            productImageId: product.productImages[0]?.id
          }));
          this.loaderService.setLoading(false);
        });
      this.modalService.dismissAll();
    }
  }

  closeBusinessModal(event: any) {
    if (event) {
      this.getDraftBusinesses();
      this.modalService.dismissAll();
    }
  }

  cropImage(imageSrc: string, x: number, y: number, width: number, height: number, widthRsp: number, heightRsp: number): Observable<string> {
    return new Observable(observer => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        console.log("ctx error");
        return;
      }

      const img = new Image();
      if (imageSrc != null || imageSrc != undefined) {
        img.crossOrigin = "anonymous";
        img.src = imageSrc;

        img.onload = () => {
          canvas.width = widthRsp;
          canvas.height = heightRsp;
          ctx.drawImage(
            img,
            x, y,
            width, height,
            0, 0,
            widthRsp, heightRsp
          );

          const croppedData = canvas.toDataURL("image/png");
          observer.next(croppedData);
          observer.complete();
        }

        img.onerror = () => {
          img.src = '../assets/images/no-image.svg';
          observer.next(img.src);
          observer.complete();
        }
      }
      else {
        img.src = '../assets/images/no-image.svg';
        observer.next(img.src);
        observer.complete();
      }

    });
  }

  setCroppedImages = (image: any, isLocal: boolean) => {

    let config = isLocal ? image.memberShipImageConfigurationViews?.find((y) => y.ImageType == 2) : image.memberShipImageConfigurationViews?.find((y) => y.imageType == 2);
    let height = isLocal ? config?.Height : config?.height;
    let width = isLocal ? config?.Width : config?.width;
    let x = isLocal ? config?.X : config?.x;
    let y = isLocal ? config?.Y : config?.y;
    this.subscribeImages = this.cropImage(image.imagePath, x, y,
      width, height, window.innerWidth, window.innerHeight)
      .subscribe({
        next: (cropped) => {
          this.imageUrls.push({
            id: image.id,
            imageType: image.imageType,
            imagePath: cropped,
          });
        },
        error: (err) => console.log("failed")
      });
  }

  getProductCategories = () => {
    this.userService.getAll(`api/tenants/membershipApp/GetAllMembershipProductCategories?businessPartnerId=${this.businessDetails.businessPartnerId}`).subscribe((productCategories: any[]) => {
      this.menuCategories = this.sortItems(productCategories.map((item: { id: any; title: any; }) => ({
        id: item.id,
        title: item.title,
      })));
    })
  }

  getDraftBusinesses(isUpdate: boolean = false) {
    this.businessService.getDraftBusiness()
      .subscribe((response: any) => {
        this.draftBusinesses = this.sortItems(response.map((item: { id: any; title: any; }) => ({
          id: item.id,
          title: item.title,
        })));
        if (isUpdate) {
          this.businessSelect = this.draftBusinesses.find(x => x.id == this.businessDetails.branchId);
          this.onChangeRestaurant(this.businessSelect);
        }
      });
  }

  getCompanyMenu() {
    this.userService.getAll(`api/tenants/membershipApp/GetCompanyMenue?SubBranchId=${this.businessDetails.branchId}&SkipPaging=true`)
      .subscribe((products: any) => {
        this.products = products.records.map((product: { id: any; title: any; productCategoryId: any; image: any; price: any; description: any; productImages: { id: any; }[]; }) => ({
          id: product.id,
          title: product.title,
          productCategoryId: product.productCategoryId,
          productImageUrl: product.image,
          price: product.price,
          description: product.description,
          productImageId: product.productImages[0]?.id
        }));
      });
  }

  onChangeRestaurant(event: any) {
    this.locationCityRequest?.unsubscribe();
    this.automaticAddress = '';
    if (event != null) {
      this.businessService
        .getBusinessById(event.id)
        .subscribe((response: any) => {
          this.businessDetails = response;
          localStorage.setItem("branchId", this.businessDetails.branchId.toString());
          this.getProductCategories();
          this.getCompanyMenu();
          this.formGroup.patchValue({
            Name: response.name?.trim(),
            Address: response.address?.trim(),
            Phone: response.phoneNumber?.trim(),
            Website: response.website?.trim(),
            Instagram: response.instagram?.trim(),
            Twitter: response.twitter?.trim(),
            BusinessMessage: response.businessMessage?.trim(),
            Description: response.description?.trim(),
            Latitude: response.lat,
            Longitude: response.lng,
            Location: response.addressLine2?.trim()
          });

          // Set initialLatLng from business lat and lng
          if (response.lat) {
            this.initialLat = response.lat;
          }
          if (response.lng) {
            this.initialLng = response.lng;
          }

          let selectedCuisine = this.cuisines.find(
            (item) => item.id === response.cuisineId
          );
          this.cuisineSelect = selectedCuisine ?? null;

          let selectedType = this.types.find((item) => item.id === response.typeId);
          this.typeSelect = selectedType ?? null;

          if (response.cityName != null && response.cityName != "") {
            this.getCitiesBySearchText(response.cityName, response.cityId);
          }

          let selectedPrice = this.priceRanges.find(
            (item) => item.id === response.priceRangeTypeId
          );
          this.priceSelect = selectedPrice ?? null;

          if (response.amenities != null) {
            this.selectedAmenities = [];
            this.selectedAmenities.push(...response.amenities);
          }
          else {
            this.selectedAmenities = [];
          }

          if (response.membershipAppMealTypeList != null) {
            this.selectedTypeOfMeals = [];
            this.selectedTypeOfMeals.push(...response.membershipAppMealTypeList.map((item) => item.id));
          }
          else {
            this.selectedTypeOfMeals = [];
          }

          if (response.membershipAppCompanyBusinessHourList && response.membershipAppCompanyBusinessHourList.length > 0) {
            this.hourList = response.membershipAppCompanyBusinessHourList.map((hour: { id: any; day: number; from: any; to: any; }) => ({
              id: hour.id,
              isOpen: true,
              Day: this.dayOfWeek.find(x => x.id == hour.day)?.name,
              From: hour.from,
              To: hour.to,
            }));
            this.businessHourAdded(this.hourList);
          } else {
            this.formGroup.controls['BusinessHourDescription'].reset();
          }
          if (response.membershipBusinessImagesList != null && response.membershipBusinessImagesList.length > 0) {
            this.allowPublish = response.membershipBusinessImagesList.every(item => item.memberShipImageConfigurationViews && item.memberShipImageConfigurationViews > 0);
            this.memberShipBranchImagesList = response.membershipBusinessImagesList;
            this.imageUrls = [];
            response.membershipBusinessImagesList.map(image => {
              if (image.memberShipImageConfigurationViews?.length > 0) {
                this.setCroppedImages(image, false);
              }
            })
          } else {
            this.imageUrls = [];
          }
        });
    } else {
      this.formGroup.reset();
      this.businessDetails.showPublishButton = false;
      this.typeSelect = null;
      this.cuisineSelect = null;
      this.citySelect = null;
      this.priceSelect = null;
      this.selectedTypeOfMeals = [];
      this.aminitySelect = null;
      this.selectedAmenities = [];
      this.products = [];
      this.imageUrls = [];
    }
  }

  cancelPreRegistration() {
    this.locationCityRequest?.unsubscribe();
    this.automaticAddress = '';
    this.getDraftBusinesses();
    this.businessDetails = new Business();
    this.businessSelect = null;
    this.formGroup.reset();
    this.typeSelect = null;
    this.cuisineSelect = null;
    this.citySelect = null;
    this.priceSelect = null;
    this.selectedTypeOfMeals = [];
    this.aminitySelect = null;
    this.selectedAmenities = [];
    this.products = [];
    this.imageUrls = [];
  }

  ngOnDestroy() {
    this.marketplaceEntryRequest?.unsubscribe();
    this.closePendingMarketplaceWindow();
    this.locationCityRequest?.unsubscribe();
    this.clearBranchRedirectInterval();
    if (this.subscribeImages) {
      this.subscribeImages.unsubscribe();
    }

    if (this.menuSubscription) {
      this.menuSubscription.unsubscribe();
    }
  }

  private clearBranchRedirectInterval() {
    if (this.branchRedirectIntervalId) {
      clearInterval(this.branchRedirectIntervalId);
      this.branchRedirectIntervalId = null;
    }
  }
}
